import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingCart, Droplets, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const NAV = [
  { label: "ACASĂ", to: "/" },
  { label: "PRODUSE", to: "/produse" },
  { label: "PACHETE AVANTAJ", to: "/produse", badge: "OFERTA" },
  { label: "DESPRE NOI", to: "/despre" },
  { label: "CONTACT", to: "/contact" },
];

export const Header = () => {
  const { count, setOpen } = useCart();
  const [mobile, setMobile] = useState(false);

  return (
    <header className="bg-white sticky top-0 z-40 shadow-sm border-b border-slate-100" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
            <span className="bg-eco rounded-xl p-2 flex items-center justify-center shadow-lg shadow-green-600/20 group-hover:scale-105 transition-transform">
              <Droplets className="h-6 w-6 text-white" />
            </span>
            <span className="leading-none">
              <span className="block font-display font-black text-xl tracking-tight text-navy">DETER<span className="text-eco">SHOP</span></span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map((n) => (
              <NavLink
                key={n.label}
                to={n.to}
                className={({ isActive }) =>
                  `relative font-display font-bold text-sm tracking-wide transition-colors ${
                    isActive ? "text-eco" : "text-navy hover:text-eco"
                  }`
                }
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
                {n.badge && (
                  <span className="ml-1.5 align-middle bg-red-600 text-white text-[9px] font-extrabold px-1.5 py-0.5 rounded">
                    {n.badge}
                  </span>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setOpen(true)}
              className="relative flex items-center gap-2 bg-navy hover:bg-navy-700 text-white font-display font-bold text-sm px-4 py-2.5 rounded-xl transition-colors"
              data-testid="cart-toggle-button"
            >
              <ShoppingCart className="h-5 w-5" />
              <span className="hidden sm:inline">COȘUL MEU</span>
              <span
                className="absolute -top-2 -right-2 bg-gold text-navy text-[11px] font-extrabold h-5 w-5 rounded-full flex items-center justify-center"
                data-testid="cart-count-badge"
              >
                {count}
              </span>
            </button>
            <button
              className="lg:hidden p-2 text-navy"
              onClick={() => setMobile((v) => !v)}
              data-testid="mobile-menu-button"
            >
              {mobile ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {mobile && (
          <nav className="lg:hidden pb-4 flex flex-col gap-1" data-testid="mobile-nav">
            {NAV.map((n) => (
              <NavLink
                key={n.label}
                to={n.to}
                onClick={() => setMobile(false)}
                className="font-display font-bold text-navy py-2.5 px-2 rounded-lg hover:bg-slate-50"
              >
                {n.label}
                {n.badge && (
                  <span className="ml-2 bg-red-600 text-white text-[9px] font-extrabold px-1.5 py-0.5 rounded">{n.badge}</span>
                )}
              </NavLink>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};
